export default __webpack_public_path__ + "ff4c144bc2a8a3da6407d5e1520310d3.jpg";